package com.xtream.composeapp.viewmodel


import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import androidx.paging.Pager
import androidx.paging.PagingConfig
import androidx.paging.PagingData
import androidx.paging.cachedIn
import androidx.paging.filter
import androidx.paging.map
import com.xtream.composeapp.SharedBuildKonfig
import com.xtream.data_kmp.AllConst
import com.xtream.data_kmp.AllConst.PAGING_PAGE_SIZE
import com.xtream.data_kmp.FavoriteSeriesStreamEntity
import com.xtream.data_kmp.PreferencesRepo
import com.xtream.data_kmp.WatchedSeriesStreams
import com.xtream.data_kmp.db.repo.SeriesStreamsRepository
import com.xtream.data_kmp.db.repo.WatchedSeriesRepository
import com.xtream.data_kmp.dto.BaseStream
import com.xtream.data_kmp.dto.CategoryWithStream
import com.xtream.data_kmp.dto.SeriesCategory
import com.xtream.data_kmp.dto.SeriesStream
import com.xtream.data_kmp.dto.TrendingTvShow
import com.xtream.data_kmp.remote.ApiService
import com.xtream.data_kmp.remote.createApiService
import io.ktor.client.call.body
import io.ktor.http.isSuccess
import kotlinx.coroutines.CoroutineExceptionHandler
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.SharingStarted
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.collectLatest
import kotlinx.coroutines.flow.combine
import kotlinx.coroutines.flow.distinctUntilChanged
import kotlinx.coroutines.flow.flatMapLatest
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.flow.stateIn
import kotlinx.coroutines.launch
import kotlinx.coroutines.withContext
import kotlinx.serialization.builtins.ListSerializer
import kotlinx.serialization.json.JsonObject
import kotlin.time.Clock

class SeriesViewModel (
    private val tvStreamsRepo: SeriesStreamsRepository,
    private val watchedStreamsRepo: WatchedSeriesRepository,
    private  val appSettingsRepo: PreferencesRepo,


) : ViewModel(),SearchViewModelInterface by SearchViewModelImpl()  {



    private val _streamState = MutableStateFlow<SeriesStream?>(null)
    val streamState: StateFlow<SeriesStream?> = _streamState

    private val _recommendedItems = MutableStateFlow<List<SeriesStream>>(emptyList())
    val recommendedItems: StateFlow<List<SeriesStream>> = _recommendedItems
     fun loadRecommendations(id: Int?) {
        if (id==null||id==-1) return
         viewModelScope.launch {
             val stream = getTvShowById(id)
             _streamState.value = stream

             stream?.let {
                 val recommended = getRecommendedTvShowsList(
                     stream.categoryId,
                     limit = 15,
                     excludeIds = listOf(stream.streamId)
                 )
                 recommended.collectLatest {
                     _recommendedItems.value = it
                 }

             }
         }
    }
    suspend fun  getTvShowById(id: Int?) = tvStreamsRepo.getTvShowByStreamId(id)

    suspend fun  getTvShowByStreamId(id: Int?) = tvStreamsRepo.getTvShowByStreamId(id)

    /**
     * gets Series Flow for given category Id and search Keyword
     * @return Flow<PagingData<SeriesStream>>
     */
    val  seriesStreamsFilteredPagingFlow = combine(searchFlow,searchByCategoryFlow) { keyWord, category ->
        category to keyWord
    }
        .distinctUntilChanged() // ✅ Prevents unnecessary reloads
        .flatMapLatest { (category, keyWord) ->
        getPagedSeriesFlow( category,keyWord)
    }.cachedIn(viewModelScope) // ✅ important!


    fun getRecommendedTvShowsList(categoryId: Int? = null,
                                  limit: Int,
                                  excludeIds:List<Int?>?=null,
                                  )=
        tvStreamsRepo.getRecommendationsList( categoryId, limit = limit,excludeIds)

    suspend fun getTopTenSeries(): List<SeriesStream>? = withContext(Dispatchers.Default) { tvStreamsRepo.getTopTens() }
    fun getAllSeriesCategoriesFlow(): Flow<List<SeriesCategory>?> =tvStreamsRepo.getCategoriesAsFlow()

    fun getSeriesCategoriesPagingFlow(
    ): Flow<PagingData<SeriesCategory>> = Pager(
        config = PagingConfig(
            pageSize = AllConst.PAGING_MIN_PAGE_SIZE,
            enablePlaceholders = false,
        ),
        pagingSourceFactory = {

            tvStreamsRepo.getCategoriesAsPagingFlow()
        }
    ).flow.cachedIn(viewModelScope)


    fun getPagedSeriesFlow(categoryId:Int?=null,searchQuery:String?=null): Flow<PagingData<SeriesStream>> = Pager<Int, SeriesStream>(
    config = PagingConfig(pageSize = PAGING_PAGE_SIZE, enablePlaceholders = false),

    pagingSourceFactory = {

        when (categoryId) {
            AllConst.ALL_CATEGORIES_ID.toInt() -> tvStreamsRepo.getStreamsAsPagingSource(categoryId =null, searchQuery)
            AllConst.FAV_CATEGORIES_ID.toInt() -> tvStreamsRepo.getFavoritesPagingSource()
            AllConst.WATCHED_CATEGORIES_ID.toInt() -> tvStreamsRepo.getPagedWatchedStreams()
            else -> tvStreamsRepo.getStreamsAsPagingSource(categoryId, searchQuery)
        }
    }

)
    .flow
    .cachedIn(viewModelScope)
    @ExperimentalStdlibApi
    val  categoriesPagerWithTvStreams = Pager(
        config = PagingConfig(
            pageSize = AllConst.PAGING_MIN_PAGE_SIZE,
            enablePlaceholders = false,
        ),
        pagingSourceFactory = {

            tvStreamsRepo.getPagedCategoriesWithStreams()
        }
    ).flow.map {
        it.map { sizedCategory->

            CategoryWithStream<Any, SeriesCategory>( category = sizedCategory.category,
                size = sizedCategory.size,
                streams =  tvStreamsRepo.all(sizedCategory.category.categoryId))
        }
            .filter {itm-> itm.streams.isNotEmpty() }
    }.cachedIn(viewModelScope)
    @ExperimentalStdlibApi
    val  getCategoriesWithStreamsPager = Pager(
        config = PagingConfig(
            pageSize = AllConst.PAGING_MIN_PAGE_SIZE,
            enablePlaceholders = false,
        ),

        pagingSourceFactory = {

            tvStreamsRepo.getCategoriesAsPagingFlow()
        }
    ).flow.map { categories ->
        // val startTime =   System.nanoTime()


        val res= categories.map {
            Pair(it,tvStreamsRepo.getStreamsFlow(it.categoryId, limit = 15))
        }
        // Log.e("Measure", "TASK took : " +  ((System.nanoTime()-startTime)/1000000)+ "mS")

        res
    }.cachedIn(viewModelScope)
   suspend fun getSeriesSize(categoryId:Int?=null): Long? = withContext(Dispatchers.Default) { tvStreamsRepo.streamsSize(categoryId) }

    /**
     * updates stream favorite status if it is not favorite it will add it and if it is already in favorites it will remove it
     */
    fun updateFavoriteStatus(stream: SeriesStream?, onDone: (Boolean) -> Unit={}){
        viewModelScope.launch {
            if (stream == null) return@launch
            if (tvStreamsRepo.isFavorite(stream.streamId))
                deleteFromFavorites(stream) {
                    onDone.invoke(false)
                }
            else {
                addToFavorites(stream)
                onDone.invoke(true)

            }
        }

    }
    /**
     * adds stream to Favorites Table
     * @property  stream stream item to be added
     **/
    suspend fun addToFavorites(stream: SeriesStream?) {

        withContext(Dispatchers.Default) {
            if (stream == null) return@withContext
            val fav = FavoriteSeriesStreamEntity().apply {
                this.streamId=  stream.streamId
                this.sortOrder=   Clock.System.now().toEpochMilliseconds()
            }
            tvStreamsRepo.insertFavorite(fav)
        }
    }
    /**
     * watched single Movie stream Flow
     */
    fun getWatchedSingleSeriesFlow(streamId: Int?) = watchedStreamsRepo.getWatchedStreamFlow(streamId)
    /**
     * watched single Movie stream Flow
     */
   suspend fun getWatchedStream(streamId: Int?) = watchedStreamsRepo.getWatchedStream(streamId)
    suspend fun removeWatched(streamId: Int?) = watchedStreamsRepo.deleteById(streamId)

        fun insertWatched( stream: WatchedSeriesStreams) {
            viewModelScope.launch(Dispatchers.Default) {
               // Log.d( "VideoPlayer", "VideoPlayer url: ${ stream.progress}, ${stream.totalProgress}")
                if (stream.progress !=null && stream.totalProgress!=null) {
                    if (stream.progress!! >= stream.totalProgress!!)
                        watchedStreamsRepo.deleteById(stream.streamId)
                    else
                        watchedStreamsRepo.insert(stream)
                }
            }
    }

    /**
     * removes stream to Favorites Table
     * @property  stream stream item to be removed
     **/
    suspend fun deleteFromFavorites(stream: SeriesStream?, onRemoved: () -> Unit) {
        withContext(Dispatchers.Default) {
            if (stream == null) return@withContext
            val fav = FavoriteSeriesStreamEntity().apply {this.streamId= stream.streamId }
            tvStreamsRepo.deleteFavorite(fav)
            onRemoved.invoke()
        }
    }
    fun getSeriesFlow(categoryId: Int? = null,
                   searchQuery: String? = null,
                   shuffle:Boolean=false,
                   limit: Int=20,
                   offset: Int?=null)= tvStreamsRepo.getStreamsFlow(categoryId=categoryId,limit = limit)

    /**
     * checks weather the given stream is available in Favorites Table?
     * @property  stream stream item to be checked
     * @return Flow< Boolean> returns true if the stream is in favorites table otherwise false
     **/
    fun isFavoriteFlow(stream: BaseStream?) =
        tvStreamsRepo.isFavoriteAsFlow(stream?.streamId)
    /**
     * checks weather the given stream is available in Favorites Table?
     * @property  stream stream item to be checked
     * @return Boolean returns true if the stream is in favorites table otherwise false
     **/
    suspend fun isFavorite(stream: BaseStream?) =
        withContext(Dispatchers.Default) {
            if (stream == null) return@withContext false
            tvStreamsRepo.isFavorite(stream.streamId) }

    private val coroutineExceptionHandler = CoroutineExceptionHandler{ _, _ ->
        //throwable.printStackTrace()

    }

    fun loadSeriesStreams(username:String,password:String,serverUrl:String): List<Job> {
        //error("implement BuildConfig.SERVER_API")
        val apiService =
            createApiService("$serverUrl${SharedBuildKonfig.SERVER_API}", username, password)
        val millis = Clock.System.now().toEpochMilliseconds()
        val streamsJob = viewModelScope.launch(Dispatchers.Default+coroutineExceptionHandler) {




           // Log.d("#dataLoading", "request: loadSeriesStreams, serverUrl: $serverUrl, username: $username, password: $password")


            // val liveStreams = apiService.getVodStreams().body<String>()
            val streams = apiService.getSeriesStreams( )
           /* Log.d(
                "#dataLoading",
                "response: loadSeriesStreams: ${((Clock.System.now().toEpochMilliseconds() - millis) / 1000)}, streams size: ${streams?.size}"
            )*/

            streams?.also { list ->
                tvStreamsRepo.refreshData(list)

              /*  list.map { it.streamId }.let { ids ->

                        objectBoxRepository.deleteWhereNotIn(
                            //listOf(386861,386859,386855)
                            SeriesStream_.streamId,
                            newIds = ids,
                            SeriesStream::class.java
                        )


                }*/


            }
           /* Log.d(
                "#dataLoading",
                "loadSeriesStreams put and deleteWhereNotIn finished in Sec: ${((Clock.System.now().toEpochMilliseconds() - millis) / 1000)}"
            )*/

        }

        val categoriesJob=viewModelScope.launch(Dispatchers.Default+coroutineExceptionHandler ) {


           // Log.d("#dataLoading", "request: loadSeriesCategories")
            val watched=
                SeriesCategory( AllConst.WATCHED_CATEGORIES_ID.toInt(), "Continue Watching")
            val favCategory=
                SeriesCategory( AllConst.FAV_CATEGORIES_ID.toInt(), "Favorites")

            val categories = apiService.getSeriesCategories()

           // Log.d("#dataLoading", "response:  loadSeriesCategories ${((Clock.System.now().toEpochMilliseconds() - millis) / 1000)}")



            categories?.also { list ->
                tvStreamsRepo.refreshCategories(listOf( favCategory,watched)+ list)
                /*list.map { it.categoryId ?: -1 }.let { ids ->


                    objectBoxRepository.deleteWhereNotIn<SeriesCategory>(
                        //listOf(386861,386859,386855)
                        SeriesCategory_.categoryId,
                        newIds = ids,
                        SeriesCategory::class.java
                    )
                }*/
            }
           // Log.d("#dataLoading", "loadSeriesCategories put and deleteWhereNotIn finished in Sec: ${((Clock.System.now().toEpochMilliseconds() - millis) / 1000)}")
          }

       val trendingJob= viewModelScope.launch(Dispatchers.Default + coroutineExceptionHandler) {

try {
    val tmdbKey: String = appSettingsRepo.getPref(PreferencesRepo.SERVER_TMDB_KEY) ?: ""
                val trending = apiService.tmdbTrendingTvShows(tmdbKey)
                if (trending.status.isSuccess()) {
                    val json = trending.body<JsonObject>()
                    val results = json["results"]
                    val tvShows: List<TrendingTvShow>? = results?.let {
                        ApiService.jsonObj.decodeFromJsonElement(
                            deserializer = ListSerializer(
                                TrendingTvShow.serializer()
                            ), it
                        )
                    }
                    tvStreamsRepo.refreshTrending(tvShows)
                }

                } catch (e:Exception){}

        }
            return listOf(categoriesJob,streamsJob, trendingJob)
          //  onResponse.invoke()

    }

    fun clearWatched() = viewModelScope.launch { watchedStreamsRepo.deleteAll() }
    fun toggleCategoryVisibility(category: SeriesCategory) {
        viewModelScope.launch {
            tvStreamsRepo.toggleCategoryVisibility(category)
        }
    }

    val categoriesWithVisibleStatus = tvStreamsRepo
        .getCategoriesWithVisibleStatus()
        .stateIn(
            scope = viewModelScope,
            started = SharingStarted.WhileSubscribed(5000),
            initialValue = emptyList()
        )
}
